import { Modal } from '@spo/storybook';
import { VpButton } from '@vtmn-play/react/headless';
import { useTranslation } from 'react-i18next';
import { ArchiModalType } from '../archiRowActions/ArchiRowActions';
import './archi-row-actions-modal.scss';

export type ArchiRowActionsModalProps = {
  modalType: ArchiModalType;
  setDisplayModalType: (modalType: ArchiModalType) => void;
  handleCloseModal: () => void;
};

const ArchiRowActionsModal = ({
  modalType,
  setDisplayModalType,
  handleCloseModal,
}: ArchiRowActionsModalProps) => {
  const { t } = useTranslation();

  const getModalInfos = (modalType: ArchiModalType) => {
    let modalInfo: { title: string; content: string } = {
      title: '',
      content: '',
    };
    switch (modalType) {
      case 'deletion':
        modalInfo = {
          title: t('architecture.modal.deletion-forbidden-title'),
          content: t('architecture.modal.deletion-forbidden'),
        };
        break;
      case 'validation':
        modalInfo = {
          title: t('architecture.modal.validation-title'),
          content: t('architecture.modal.validation'),
        };
        break;
      case 'error':
        modalInfo = {
          title: t('architecture.modal.deletion-error-title'),
          content: t('architecture.modal.deletion-error'),
        };
        break;
      default:
        modalInfo = {
          title: '',
          content: '',
        };
    }
    return modalInfo;
  };

  const footerModal = (
    <VpButton
      data-testid="archi-modal-ok-button"
      onClick={handleCloseModal}
      variant="primary"
      shape="squared"
      aria-label="Close the modal"
    >
      {t('ok')}
    </VpButton>
  );

  return (
    <Modal
      dataTestid="archi-warning-modal"
      footer={footerModal}
      isOpen={Boolean(modalType)}
      title={getModalInfos(modalType).title}
      ariaLabel="Architecture Warning Modal"
      onClose={() => setDisplayModalType(null)}
    >
      <div
        className="modal-warning-content"
        data-testid={`modal-warning-content-${modalType}`}
      >
        {getModalInfos(modalType).content}
      </div>
    </Modal>
  );
};

export default ArchiRowActionsModal;
